"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.flowSelector = flowSelector;
function flowSelector(state) {
  return state.activeFlow;
}